module.exports = __webpack_public_path__ + "img/footer-img.25146673.png";